import React from "react";
import clsx from "clsx";

import withStyles from "@material-ui/core/styles/withStyles";
import {Grid} from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";

import BcaIconButton from "../../../../../components/Buttons/BcaIconButton/BcaIconButton";
import Summary from "../../../Summary";
import AssetsList from "../../../AssetsList";
import LiabilitiesList from "../../../LiabilitiesList";
import {useOtherAssetsData} from "../../../../CustomerDashboardV2/hooks/useOtherAssetsData";
import {MENUS} from "../../constants";
import {getErrorMessage} from "../../../../../utils/utils";
import useOtherAssetsAndLiabilitiesData from "../../../hooks/useOtherAssetsAndLiabilitiesData";

import styles from "./styles";


const Content = (props) => {
  const {
    classes,
    allowSync,
    defaultTab,
    setChanged,
    customerId,
    startDate,
    endDate,
    excludedPortfolios,
    withOtherAssets,
    withLiabilities
  } = props;

  const [selectedTab, setSelectedTab] = React.useState(defaultTab);
  const [data, fetch, dispatchAssetsAndLiabilities] = useOtherAssetsAndLiabilitiesData(
    customerId, startDate, endDate, withOtherAssets, withLiabilities
  );
  const [depotsAndCashData, fetchDepotsAndCash] = useOtherAssetsData(
    customerId, [], startDate, endDate, false, false, true, true, excludedPortfolios);

  const onAddFromSummary = (itemType, type, categoryId, item) => {
    setChanged();
    dispatchAssetsAndLiabilities({type, itemType, categoryId, item, endDate});
  };

  const onDepotsUpdate = () => {
    setChanged('depot');
    fetchDepotsAndCash();
  };

  const retry = () => {
    if(data.error) {
      fetch();
    }
    if(depotsAndCashData.error) {
      fetchDepotsAndCash();
    }
  };

  const error = data.error || depotsAndCashData.error;

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12} sm={'auto'} className={classes.sideMenu}>
        {Object.values(MENUS).filter(tab => (tab.id !== MENUS.assets.id || withOtherAssets) && ((tab.id !== MENUS.liabilities.id || withLiabilities))).map(tab => (
          <ListItem
            key={tab.id}
            button
            classes={{
              root: clsx(classes.listItemRoot, tab.id !== MENUS.summary.id && classes.listItemRootNested),
              selected: classes.listItemSelected
            }}
            selected={selectedTab === tab.id}
            onClick={() => setSelectedTab(tab.id)}
          >{tab.title}</ListItem>
        ))}
      </Grid>
      <Grid item xs={12} sm className={classes.mainPage}>
        {!!error ? (
          <div style={{textAlign: 'center'}}>
            <b>{getErrorMessage(error)}</b>
            <BcaIconButton
              icon={<i className={'fa fa-refresh'} />}
              tooltip={'Erneut versuchen'}
              onClick={retry}
            />
          </div>
        ) : (<>
          {selectedTab === MENUS.summary.id && (
            <Summary
              assetsAndLiabilitiesData={data}
              depotsAndCashData={depotsAndCashData}
              stepName={"Gesamtvermögen"}
              customerId={customerId}
              onAdd={onAddFromSummary}
              withOtherAssets={withOtherAssets}
              withLiabilities={withLiabilities}
            />
          )}
          {selectedTab === MENUS.assets.id && (
            <AssetsList
              allowSync={allowSync}
              customerId={customerId}
              data={data}
              depotsAndCashData={depotsAndCashData}
              name={"Vermögenswerte"}
              onDepotsUpdate={onDepotsUpdate}
              onUpdate={onAddFromSummary}
            />
          )}
          {selectedTab === MENUS.liabilities.id && (
            <LiabilitiesList
              allowSync={allowSync}
              customerId={customerId}
              data={data}
              name={"Verbindlichkeiten"}
              onUpdate={onAddFromSummary}
            />
          )}
        </>)}
      </Grid>
    </Grid>
  )
};

Content.defaultProps = {
  defaultTab: MENUS.summary.id,
  withOtherAssets: true,
  withLiabilities: true,
};

export default withStyles(styles)(Content);